import Guest from '@/layouts/guest';
import React, {useEffect} from 'react';
import {Container} from "react-bootstrap";
import RegisterContent from "@/components/auth/register-content";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

const Register: React.FC = () => {
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.user);

    useEffect(() => {
        if(user) return navigate('/');
    }, [user]);

    return (
        <>
            {!user ? (
                <Guest title="عضویت">
                    <Container className="py-5">
                        <RegisterContent />
                    </Container>
                </Guest>
            ) : (<></>)}
        </>
  );
}

export default Register;
